import { useLayoutEffect, useRef } from 'react'

import { useGSAP } from '@/composables/useGSAP'

export type SummaryHeroExitSwirlProps = {
  className?: string
}

export default function SummaryHeroExitSwirl({ className }: SummaryHeroExitSwirlProps) {
  const { gsap } = useGSAP()

  const pathOut1Ref = useRef<SVGPathElement>(null)
  const pathOut2Ref = useRef<SVGPathElement>(null)

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap
        .timeline()
        .addLabel('path', 0)
        .fromTo(
          [pathOut1Ref.current, pathOut2Ref.current],
          {
            drawSVG: '0% 0%',
          },
          {
            drawSVG: '0% 100%',
            duration: 0.5,
            stagger: 0.15,
            ease: 'power1.in',
          },
          'path'
        )
        .to(
          [pathOut2Ref.current, pathOut1Ref.current],
          {
            drawSVG: '100% 100%',
            duration: 0.5,
            stagger: 0.15,
            ease: 'power1.inOut',
          },
          'path+=0.65'
        )
    })

    return () => ctx.kill()
  }, [pathOut1Ref, pathOut2Ref, gsap])

  return (
    <svg
      aria-hidden
      className={`SummaryHeroExitSwirl ${className ? className : ''} absolute z-2 top-[73%] md:top-1/2 -translate-y-1/2 right-[7.5vw] md:-right-[15vw] w-screen pointer-events-none`}
      viewBox='0 0 1440 844'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        ref={pathOut1Ref}
        d='M342.048 456.655C224.919 547.43 644.431 636.081 523.431 686.081C510.492 691.428 555.135 525.586 681.136 665.586C699.582 686.081 705.137 694.585 705.137 694.585'
        stroke='currentColor'
        strokeWidth='1.5'
        className='opacity-30'
      />
      <path
        ref={pathOut2Ref}
        d='M342.048 456.655C224.919 547.43 644.431 636.081 523.431 686.081C510.492 691.428 555.135 525.586 681.136 665.586C699.582 686.081 705.137 694.585 705.137 694.585'
        stroke='currentColor'
        strokeWidth='1.5'
        className='opacity-100'
      />
    </svg>
  )
}
